import {
  trackSelfDescribingEvent,
  trackStructEvent,
} from '@snowplow/browser-tracker'
import { Plan } from '../types'

export function trackOnboardingFormData({
  formData,
  url,
  orderedRoutes,
}: {
  formData: FormData
  url: string
  orderedRoutes: string[]
}) {
  const entries = Array.from(formData.entries())
  const keys = [...new Set(entries.map(([key]) => key))]

  const pathname = new URL(url).pathname
  const currentPage = pathname.split('/').pop() || ''
  const currentIndex = orderedRoutes.indexOf(currentPage)
  const step = currentIndex !== -1 ? currentIndex + 1 : undefined
  const steps_total = orderedRoutes.length

  for (const key of keys) {
    trackSelfDescribingEvent({
      event: {
        schema: 'iglu:com.asanarebel/onboarding_event/jsonschema/1-0-0',
        data: {
          answers: formData.getAll(key).map(String),
          question: key,
          step,
          steps_total,
          url,
        },
      },
    })
  }
}

export function trackCheckoutTermsToggle({
  isAccepted,
  plan,
  priceId,
  value,
}: {
  isAccepted: boolean
  plan: Plan
  priceId: string | undefined
  value: number | undefined
}) {
  trackStructEvent({
    category: 'checkout',
    action: 'terms_checkbox_toggle',
    label: plan,
    property: [isAccepted ? 'checked' : 'unchecked', priceId]
      .filter(Boolean)
      .join(':'),
    value,
  })
}
